// extracted by mini-css-extract-plugin
export default {"lessonList":"SongDetailsLessonsList_lessonList__-9km3"};